/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Amenities_SummaryInputs */

const en_field_amenities_summary = /** @type {(inputs: Field_Amenities_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key Amenities`)
};

const es_field_amenities_summary = /** @type {(inputs: Field_Amenities_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servicios clave`)
};

const fr_field_amenities_summary = /** @type {(inputs: Field_Amenities_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principaux équipements`)
};

const de_field_amenities_summary = /** @type {(inputs: Field_Amenities_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wichtige Ausstattungsmerkmale`)
};

const ja_field_amenities_summary = /** @type {(inputs: Field_Amenities_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主な設備`)
};

const zh_field_amenities_summary = /** @type {(inputs: Field_Amenities_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`核心设施`)
};

const ar_field_amenities_summary = /** @type {(inputs: Field_Amenities_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أبرز المرافق`)
};

const id_field_amenities_summary = /** @type {(inputs: Field_Amenities_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fasilitas Utama`)
};

const it_field_amenities_summary = /** @type {(inputs: Field_Amenities_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servizi Principali`)
};

const ru_field_amenities_summary = /** @type {(inputs: Field_Amenities_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ключевые удобства`)
};

const pt_field_amenities_summary = /** @type {(inputs: Field_Amenities_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principais Comodidades`)
};

const ko_field_amenities_summary = /** @type {(inputs: Field_Amenities_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주요 편의 시설`)
};

/**
* | output |
* | --- |
* | "Key Amenities" |
*
* @param {Field_Amenities_SummaryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_amenities_summary = /** @type {((inputs?: Field_Amenities_SummaryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Amenities_SummaryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_amenities_summary(inputs)
	if (locale === "es") return es_field_amenities_summary(inputs)
	if (locale === "fr") return fr_field_amenities_summary(inputs)
	if (locale === "de") return de_field_amenities_summary(inputs)
	if (locale === "ja") return ja_field_amenities_summary(inputs)
	if (locale === "zh") return zh_field_amenities_summary(inputs)
	if (locale === "ar") return ar_field_amenities_summary(inputs)
	if (locale === "id") return id_field_amenities_summary(inputs)
	if (locale === "it") return it_field_amenities_summary(inputs)
	if (locale === "ru") return ru_field_amenities_summary(inputs)
	if (locale === "pt") return pt_field_amenities_summary(inputs)
	return ko_field_amenities_summary(inputs)
});